import get from '../../utils/get';
import set from '../../utils/set';
function mergeData(records, master, values) {
  var masterData = records[master];
  var result = Object.assign({}, masterData);
  Object.keys(values).forEach(function (key) {
    var value = values[key];
    if (typeof value === 'number') {
      // A little crazy to handle nested props like journal.journal_name
      result = set(key)(get(key)(records[value]))(result);
    } else if (typeof value === 'object') {
      result[key] = records.reduce(function (acc, record, col) {
        if (record[key]) {
          var add = value !== null ? record[key].filter(function (val, row) {
            return value["r".concat(row, "-c").concat(col)];
          }) : null;
          if (col !== master && add) {
            add = add.map(function (entry) {
              var result = Object.assign({}, entry);
              delete result.id;
              return result;
            });
          }
          return acc.concat(add);
        }
        return acc;
      }, []);
    } else {
      result[key] = mergeData(records.map(function (record) {
        return record[key];
      }), master, values[key]);
    }
  });
  return result;
}
export default function (records, master, values) {
  return mergeData(records.map(function (record) {
    return record.data;
  }), master, values);
}